import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useAuth } from '../../context/AuthContext';

const BannerPopup = () => {
   const { user } = useAuth();
  const [banners, setBanners] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const userRole = user?.role;

        // Only show banners to students
        if (userRole !== 'student') {
          setLoading(false);
          return;
        }

        const response = await axios.get('/api/banners/active');
        const activeBanners = response.data.banners;

        if (activeBanners && activeBanners.length > 0) {
          // Check cookie for today
          const today = new Date().toDateString();
          const lastShownDate = Cookies.get('bannerLastShown');
          const daysShown = parseInt(Cookies.get('bannerDaysShown') || '0');

          if (lastShownDate !== today || daysShown === 0) {
            setBanners(activeBanners);
            setShow(true);
            // Set cookies to expire in 12 hours
            Cookies.set('bannerLastShown', today, { expires: 0.5 });
            Cookies.set('bannerDaysShown', '1', { expires: 0.5 });
          }
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  const handleBannerClick = (redirectUrl) => {
    window.open(redirectUrl, '_blank');
    setShow(false);
  };

  const nextBanner = () => {
    setCurrentBannerIndex((prev) =>
      prev === banners.length - 1 ? 0 : prev + 1
    );
  };

  const prevBanner = () => {
    setCurrentBannerIndex((prev) =>
      prev === 0 ? banners.length - 1 : prev - 1
    );
  };

  if (loading || banners.length === 0 || !show) {
    return null;
  }

  const currentBanner = banners[currentBannerIndex];

  return (
     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{zIndex:'9999999999'}}>
      <div className="rounded-lg shadow-2xl w-full mx-4 relative overflow-hidden" style={{width:'auto',maxWidth:'100%', height:'auto', maxHeight:'90%'}}>
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 z-10 text-gray-500 hover:text-gray-700 rounded-full p-1 shadow-md"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>

        {banners.length > 1 && (
          <>
            {/* Navigation arrows */}
            <button
              onClick={prevBanner}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 text-white bg-black bg-opacity-20 rounded-full p-1 hover:bg-opacity-40 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            <button
              onClick={nextBanner}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 text-white bg-black bg-opacity-20 rounded-full p-1 hover:bg-opacity-40 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>

            {/* Dots indicator */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10 flex space-x-2">
              {banners.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentBannerIndex(index)}
                  className={`w-2 h-2 rounded-full transition-colors ${
                    index === currentBannerIndex ? 'bg-white' : 'bg-white bg-opacity-50'
                  }`}
                />
              ))}
            </div>
          </>
        )}

        {/* Banner content */}
        <div
          className="cursor-pointer"
          onClick={() => handleBannerClick(currentBanner.redirectUrl)}
        >
          <img
            src={currentBanner.imageUrl}
            alt={currentBanner.title}
            className="mx-auto"
            style={{
              maxHeight:'90vh',
              maxWidth: '100%',
              objectFit: 'contain',
            }}
          />
          {/* <div className="p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {currentBanner.title}
            </h3>
            <p className="text-gray-600 text-sm">
              {currentBanner.description}
            </p>
            <div className="mt-4 text-center">
              <span className="inline-block bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
                Learn More
              </span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default BannerPopup;
